<template>
  <Teleport to="body">
    <cl-modal
      :close-modal-text="$t('close')"
      :visible="visible"
      test-id="saml-toggle-confirmation-modal"
      @on-close="onClose"
    >
      <template #[`header.title`]>
        <slot name="title">
          <cl-heading :size="'h4'">
            {{ t("disable-saml-sso") }}
          </cl-heading>
        </slot>
      </template>
      <slot name="body">
        <template v-if="status">
          <div class="tw-ml-6">
            <div
              v-dompurify-html="t('saml-disable-confirm-lead-in')"
              class="tw-pb-4"
            />
            <ul class="tw-list-disc">
              <li>
                {{ t("login-username-password-tooltip") }}
              </li>
            </ul>
          </div>
        </template>
      </slot>
      <template #[`footer.decline`]>
        <slot name="decline">
          <cl-button
            variant="secondary-ghost"
            data-test-id="saml-disable-cancel"
            @on-click="onClose"
          >
            {{ t("cancel") }}
          </cl-button>
        </slot>
      </template>
      <template #[`footer.accept`]>
        <slot name="enable">
          <cl-button
            variant="secondary"
            data-test-id="saml-disable-confirm"
            :disabled="isRequestPending"
            @on-click="confirm"
          >
            <cl-spinner
              :loading-text="$t('loading')"
              v-if="isRequestPending"
              :size="'small'"
              class="tw-mr-2"
            />
            <span>{{ t("confirm") }}</span>
          </cl-button>
        </slot>
      </template>
    </cl-modal>
  </Teleport>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import {
  useRequestStatus,
  PENDING,
  READY,
} from "@/composables/useRequestStatus";

type Props = { visible?: boolean; status: boolean };
withDefaults(defineProps<Props>(), {
  visible: false,
});
const { t } = useI18n();
const { setRequestStatus, isRequestPending } = useRequestStatus({
  type: READY,
});

const emit = defineEmits<{
  (event: "on-confirm"): void;
  (event: "on-close"): void;
}>();

const onClose = () => {
  emit("on-close");
};
const confirm = () => {
  setRequestStatus({ type: PENDING });

  emit("on-confirm");

  setTimeout(() => {
    setRequestStatus({ type: READY });
  }, 1000);
};
</script>
